import * as React from 'react';

import { Chip } from '@longline/aqua-ui/controls/Chip';
import { Input } from '@longline/aqua-ui/inputs/Input';
import { Form } from '@longline/aqua-ui/containers/Form';
import { Filter } from '@longline/aqua-ui/modules/Filter';
import { CountryFormatter } from '@longline/aqua-ui/formatters/CountryFormatter';
import { DivisionFormatter } from '@longline/aqua-ui/formatters/DivisionFormatter/DivisionFormatter';
import { CountryDropdown } from '@longline/aqua-ui/modules/CountryDropdown';
import { DivisionDropdown } from '@longline/aqua-ui/modules/DivisionDropdown';

import { SearchFilter } from '../ui/SearchFilter';

interface ISystemFilter {
  q?: string;
  country?: string;
  division?: string;
}

interface IProps {
  filter: ISystemFilter;
  onChange: (filter: ISystemFilter) => void;
}

const hasFilter = (filter: ISystemFilter) => 
      (filter.q != null && filter.q != "") 
  || filter.country != null 
  || filter.division != null;
  
const SystemFilter = (props: IProps) => {

  const handleChange = (name: string, value: any) => {
    const newFilter: ISystemFilter = {...props.filter};
    (newFilter as any)[name] = value;
    // If country changes, division is reset.
    if(name == 'country') {
      newFilter.division = undefined;
    }
    props.onChange(newFilter);
  }

  return (
    <SearchFilter>
      <SearchFilter.Chips>
        {props.filter.country != null && 
          <Chip onClick={() => handleChange("country", null)}>
            <CountryFormatter type='both' value={props.filter.country}/>
          </Chip>}
        {props.filter.division != null && 
          <Chip onClick={() => handleChange("division", null)}>
            <DivisionFormatter value={props.filter.division}/>
          </Chip>}          
      </SearchFilter.Chips>
      <SearchFilter.Controls>
        <Input fluid clearable value={props.filter.q} type="text" placeholder="Filter systems by name" autocomplete="off" onChange={(value) => handleChange("q", value)}/>
        <Filter active={hasFilter(props.filter)}>
          <Form.Field
            label="Country"
            name="country"
            value={props.filter.country} 
            wrapper='box'
            onChange={(value) => handleChange("country", value)}
            control={<CountryDropdown clearable/>}
            hint="Filter by country"
          />
          <Form.Field
            label="Administrative division"
            name="division"
            value={props.filter.division} 
            wrapper='box'
            disabled={!props.filter.country}
            onChange={(value) => handleChange("division", value)}
            control={<DivisionDropdown clearable country={props.filter.country ?? ""}/>}
            hint="Filter by administrative division"
          />          
        </Filter>
      </SearchFilter.Controls>
    </SearchFilter>    
  )
}

export { SystemFilter, ISystemFilter, hasFilter }
